export const isEven = (number: number): boolean => {
  if (number % 2 == 0) return true;
  else return false;
};

export const dateFormatter = (date: string): string => {
  try {
    const dateObject = new Date(date);
    return new Intl.DateTimeFormat("fr-FR").format(dateObject);
  } catch (exception) {
    console.warn(exception);
  }
};

export const getTimeFromDate = (date: string): string => {
  try {
    const dateObject = new Date(date);
    return dateObject
      .toLocaleTimeString()
      .match(/\d{2}:\d{2}|[AMP]+/g)
      .join(" ");
  } catch (exception) {
    console.warn(exception);
  }
};

export const sortArticles = (articles: Object[]) => {
  return articles.sort((a: any, b: any) => {
    return new Date(b.sys.createdAt).getTime() - new Date(a.sys.createdAt).getTime();
  });
};
